import { useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDAutocomplete from "components/MDAutocomplete";
import api from "services/api";

const kategoriOptions = [
  { value: "PENGADUAN", label: "Pengaduan" },
  { value: "SARAN", label: "Saran / Masukan" },
  { value: "PERTANYAAN", label: "Pertanyaan" },
  { value: "LAINNYA", label: "Lainnya" },
];

function ComplaintSection() {
  const [form, setForm] = useState({
    nama: "",
    email: "",
    no_hp: "",
    kategori: "PENGADUAN",
    subjek: "",
    pesan: "",
  });
  const [sending, setSending] = useState(false);
  const [snack, setSnack] = useState({ open: false, severity: "success", message: "" });

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSelectChange = (field) => (value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nama.trim() || !form.subjek.trim() || !form.pesan.trim()) {
      setSnack({ open: true, severity: "error", message: "Nama, subjek, dan pesan wajib diisi." });
      return;
    }

    setSending(true);
    try {
      const res = await api.post("public/pengaduan", form);
      setSnack({
        open: true,
        severity: "success",
        message: res.data?.message || "Pengaduan berhasil dikirim.",
      });
      setForm({ nama: "", email: "", no_hp: "", kategori: "PENGADUAN", subjek: "", pesan: "" });
    } catch (err) {
      setSnack({
        open: true,
        severity: "error",
        message: err.response?.data?.message || "Gagal mengirim pengaduan.",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <MDBox id="pengaduan" component="section" py={8} sx={{ background: "linear-gradient(135deg, #e3f2fd 0%, #e8f5e9 100%)" }}>
      <Container>
        <Grid container spacing={4} alignItems="stretch">
          <Grid item xs={12} md={5}>
            <MDBox height="100%" display="flex" flexDirection="column" justifyContent="center">
              <MDTypography variant="h3" fontWeight="bold" mb={2}>
                Pengaduan & Masukan
              </MDTypography>
              <MDTypography variant="body1" color="text" mb={2}>
                Sampaikan keluhan, saran, atau pertanyaan Anda terkait pelayanan DPMPTSP Kabupaten
                Rote Ndao. Tim kami akan menindaklanjuti setiap masukan yang masuk.
              </MDTypography>
              <MDBox
                p={2.5}
                borderRadius="lg"
                bgColor="white"
                shadow="md"
              >
                <MDTypography variant="button" fontWeight="bold" mb={1}>
                  Informasi Kontak Dinas
                </MDTypography>
                <MDTypography variant="body2" color="text">
                  DPMPTSP Kabupaten Rote Ndao
                </MDTypography>
                <MDTypography variant="body2" color="text">
                  Provinsi Nusa Tenggara Timur
                </MDTypography>
                <MDTypography variant="body2" color="text" mt={1}>
                  Email: dpmptsp.rotenao@kab.go.id
                </MDTypography>
                <MDTypography variant="body2" color="text">
                  Telepon: (0380) —— ———
                </MDTypography>
              </MDBox>
            </MDBox>
          </Grid>

          <Grid item xs={12} md={7}>
            <Card>
              <MDBox p={3} component="form" onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <MDInput
                      label="Nama Lengkap *"
                      fullWidth
                      value={form.nama}
                      onChange={handleChange("nama")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <MDInput
                      label="No. HP"
                      fullWidth
                      value={form.no_hp}
                      onChange={handleChange("no_hp")}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MDInput
                      label="Email"
                      type="email"
                      fullWidth
                      value={form.email}
                      onChange={handleChange("email")}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MDAutocomplete
                      label="Kategori"
                      fullWidth
                      options={kategoriOptions}
                      value={form.kategori}
                      onChange={handleSelectChange("kategori")}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MDInput
                      label="Subjek *"
                      fullWidth
                      value={form.subjek}
                      onChange={handleChange("subjek")}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MDInput
                      label="Pesan *"
                      fullWidth
                      multiline
                      rows={4}
                      value={form.pesan}
                      onChange={handleChange("pesan")}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MDButton variant="gradient" color="info" type="submit" disabled={sending} fullWidth>
                      {sending ? "Mengirim..." : "Kirim Pengaduan / Masukan"}
                    </MDButton>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </Container>

      <Snackbar
        open={snack.open}
        autoHideDuration={6000}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snack.severity} onClose={() => setSnack((s) => ({ ...s, open: false }))}>
          {snack.message}
        </Alert>
      </Snackbar>
    </MDBox>
  );
}

export default ComplaintSection;
